import React from 'react';

import { Container, Step, Description, ChildrenContainer } from './styles';

interface IProps {
  step: string;
  description: string;
  'data-cy'?: string;
}

const StepItem: React.FC<IProps> = ({ step, description, children, 'data-cy': dataCy }) => (
  <Container>
    <Step
      data-cy={dataCy && `${dataCy}`}>
      {step}
    </Step>
    <Description
      data-cy={dataCy && `${dataCy}-description`}>
      {description}
    </Description>
    {children && (
      <ChildrenContainer
        data-cy={dataCy && `${dataCy}-child-container`}>
        {children}
      </ChildrenContainer>
    )}
  </Container>
);

export default StepItem;
